// extracted by mini-css-extract-plugin
export default {"toggle":"ThemeToggle_toggle__LNEqc","icon":"ThemeToggle_icon__zAnfz"};